// document.addEventListener('DOMContentLoaded', () => {
//   const loader = document.querySelector('.loading');
//   if (loader) {
//     loader.classList.remove('loading--show');
//   }
// });
// forms validate
import { numberFunctions } from "../common/constants/functions/numberFunctions";
import { addTextValidation, getDeviceType } from "../common/constants/variables/globalVariables";
import { getCardMap } from "../../../../../../modules/custom/ev_results/js/components/map";
import { initHomeMap } from "./loadMap";
import { Slider } from "../common/services/sliderService";
import { initWhenReady } from "./sliders";
import { scrollTabIntoView } from "../partials/scrollNav";
import { formState } from "../modules/form/FormState";
window.openZonesMap = openZonesMap;
window.initHomeMap = initHomeMap;
// validar que no permita ingresar numeros
const texto = document.querySelectorAll('.content-text input');
addTextValidation(texto);
// Bandera para cargar popup después de confetti
const CONFETTI_ENABLED = true;
// validar que no permita ingresar letras
const number = document.querySelectorAll('.content-number input');
number.forEach((input) => {
    const htmlInput = input;
    htmlInput.addEventListener('keydown', (e) => {
        numberFunctions.blockLetters(e);
    }, true);
});
function orderCity() {
    const selectElement = document.querySelector('.content-select-ciudad select');
    if (selectElement) {
        const options = Array.from(selectElement.options);
        const [foption, ...restOptions] = options;
        const sortedOptions = restOptions.sort((a, b) => a.textContent.localeCompare(b.textContent));
        selectElement.innerHTML = '';
        selectElement.append(foption, ...sortedOptions);
    }
}
// Sondeo
function loadSondeo() {
    var _a, _b, _c;
    let IDPopup = ((_a = document.querySelector('.js-sondeo-pop-up')) === null || _a === void 0 ? void 0 : _a.getAttribute('id')) || '';
    let popup = document.getElementById(IDPopup) ? document.getElementById(IDPopup) : null;
    if (popup) {
        if (localStorage.getItem(IDPopup) == 'active') {
            (_b = document.getElementById('pop-up-portal')) === null || _b === void 0 ? void 0 : _b.classList.add('pop-hidden');
        }
        else {
            (_c = document.getElementById('pop-up-portal')) === null || _c === void 0 ? void 0 : _c.classList.add('d-flex');
        }
        popup.addEventListener("click", function () {
            var _a;
            if (document.getElementById('pop-up-portal')) {
                (_a = document.getElementById('pop-up-portal')) === null || _a === void 0 ? void 0 : _a.classList.add('pop-hidden');
                localStorage.setItem(IDPopup, 'active');
            }
        });
    }
}
function loadPopUpAd(IDPopup) {
    var _a, _b;
    const popup = IDPopup ? document.getElementById(IDPopup) : '';
    if (popup) {
        if (localStorage.getItem(IDPopup) == 'active') {
            (_a = document.querySelector('.pop-up-ad')) === null || _a === void 0 ? void 0 : _a.classList.add('pop-hidden');
        }
        else {
            (_b = document.querySelector('.pop-up-ad')) === null || _b === void 0 ? void 0 : _b.classList.add('d-flex');
        }
        popup.addEventListener("click", function () {
            var _a;
            if (document.querySelector('.pop-up-ad')) {
                (_a = document.querySelector('.pop-up-ad')) === null || _a === void 0 ? void 0 : _a.classList.add('pop-hidden');
                localStorage.setItem(IDPopup, 'active');
            }
        });
    }
}
function showPopupPrincipal() {
    const popup = document.querySelector('.pop-up-ad-principal');
    const content = popup === null || popup === void 0 ? void 0 : popup.querySelector('.content-popup');
    if (!popup)
        return;
    popup.classList.remove('pop-hidden');
    content === null || content === void 0 ? void 0 : content.classList.remove('d-none');
    popup.classList.add('d-flex', 'w-100');
    void popup.offsetWidth;
    popup.classList.add('is-visible');
}
function hidePopupPrincipal(IDPopupPrincipal) {
    const popup = document.querySelector('.pop-up-ad-principal');
    const content = popup === null || popup === void 0 ? void 0 : popup.querySelector('.content-popup');
    if (!popup)
        return;
    popup.classList.remove('is-visible');
    window.setTimeout(() => {
        popup.classList.add('pop-hidden');
        popup.classList.remove('w-100');
        content === null || content === void 0 ? void 0 : content.classList.add('d-none');
        localStorage.setItem(IDPopupPrincipal, 'active');
    }, 350);
}
function loadCookies() {
    const cookiesBannerInfo = document.querySelector('.cookiesjsr-banner__info, .cookiesjsr-banner--info');
    if (cookiesBannerInfo) {
        const alreadyHasDetails = document.querySelector('.cookiesjsr-banner--text--details');
        const alreadyHasReadMore = document.querySelector('.cookiesjsr-banner--text--read-more');
        if (!alreadyHasDetails) {
            const textCookies = `
        <span class="cookiesjsr-dots">...</span>
        <span class="cookiesjsr-banner--text--details">
          , generar análisis estadísticos y entregar publicidad que pueda llegar a ser de su interés guiados por sus preferencias de navegación. Al navegar por nuestro sitio web, acepta nuestra Política de Cookies.
        </span>
      `;
            cookiesBannerInfo.innerHTML += textCookies;
        }
        const aditionalTextCookies = document.querySelector('.cookiesjsr-banner--text--details');
        const dotsTextCookies = document.querySelector('.cookiesjsr-dots');
        if (!alreadyHasReadMore) {
            const readMore = document.createElement('a');
            readMore.href = '#';
            readMore.classList.add('cookiesjsr-banner--text--read-more');
            readMore.textContent = 'Leer más';
            cookiesBannerInfo.appendChild(readMore);
            readMore.addEventListener('click', function (e) {
                e.preventDefault();
                if (!aditionalTextCookies || !dotsTextCookies)
                    return;
                const isHidden = aditionalTextCookies.style.display === 'none' ||
                    aditionalTextCookies.style.display === '';
                if (isHidden) {
                    dotsTextCookies.style.display = 'none';
                    aditionalTextCookies.style.display = 'inline';
                    readMore.textContent = 'Leer menos';
                }
                else {
                    aditionalTextCookies.style.display = 'none';
                    dotsTextCookies.style.display = 'inline';
                    readMore.textContent = 'Leer más';
                }
            });
        }
    }
    setTimeout(() => {
        if (document.querySelector('.content-banner-top img[width="400"]')) {
            document.body.style.paddingTop = '140px';
        }
    }, 100);
}
export function loadScript() {
    window.addEventListener("load", function () {
        var _a, _b, _c;
        let IDPopup = ((_a = document.querySelector('.js-close-popup-ad')) === null || _a === void 0 ? void 0 : _a.getAttribute('id')) || '';
        let fecha = new Date();
        if (fecha.toLocaleDateString('es-ES') != localStorage.getItem('fecha-' + IDPopup)) {
            localStorage.setItem('fecha-' + IDPopup, fecha.toLocaleDateString('es-ES'));
            localStorage.removeItem(IDPopup);
        }
        let IDPopupPrincipal = ((_b = document.querySelector('.close-popup-ad-principal')) === null || _b === void 0 ? void 0 : _b.getAttribute('id')) || '';
        if (fecha.toLocaleDateString('es-ES') != localStorage.getItem('fecha-ad-' + IDPopupPrincipal)) {
            localStorage.setItem('fecha-ad-' + IDPopupPrincipal, fecha.toLocaleDateString('es-ES'));
            localStorage.removeItem(IDPopupPrincipal);
        }
        const contextDevice = getDeviceType();
        let device = contextDevice == 'mobile' ? "300" : "800";
        const popupPrincipal = IDPopupPrincipal ? document.getElementById(IDPopupPrincipal) : '';
        if (localStorage.getItem(IDPopup) != 'active') {
            loadPopUpAd(IDPopup);
        }
        if (popupPrincipal && (document.querySelector(".pop-up-ad-principal" + " img[width='" + device + "']") || document.querySelector(".pop-up-ad-principal.white-brand"))) {
            if (localStorage.getItem(IDPopupPrincipal) == 'active') {
                (_c = document.querySelector('.pop-up-ad-principal')) === null || _c === void 0 ? void 0 : _c.classList.add('pop-hidden');
                if (localStorage.getItem('close-sondeo-evento') != 'active') {
                    loadSondeo();
                }
            }
            else {
                showPopupPrincipal();
            }
            popupPrincipal === null || popupPrincipal === void 0 ? void 0 : popupPrincipal.addEventListener("click", () => {
                hidePopupPrincipal(IDPopupPrincipal);
                loadPopUpAd(IDPopup);
                loadSondeo();
            });
        }
        else if ((document.getElementById('pop-up-portal') && localStorage.getItem('close-sondeo-evento') != 'active') && (document.getElementById(IDPopup) && localStorage.getItem(IDPopup) != 'active')) {
            const functions = [loadPopUpAd, loadSondeo];
            functions[Math.floor(Math.random() * functions.length)](IDPopup);
        }
        else {
            loadPopUpAd(IDPopup);
            loadSondeo();
        }
        // cookies
        loadCookies();
        // city contactenos
        orderCity();
        if (this.window.location.pathname == '/') {
            // Cargar mapa en home
            initHomeMap();
            loadInitialMarkers();
            //Inicializa carousel auto scroll
            initAutoScroll('.featured-zones', 0.2);
            initFeaturedZones();
            assignZoneLinks();
        }
    });
    // masterclass
    if (window.location.pathname == "/dataliving/masterclass/memorias") {
        document.querySelectorAll('.modal-gallery').forEach(modal => {
            modal.addEventListener('show.bs.modal', () => {
                const sliderEl = modal.querySelector('.splide');
                const loader = modal.querySelector('.loading-results');
                const closeBtn = modal.querySelector('.close-btn');
                if (loader)
                    loader.classList.remove('d-none');
                if (sliderEl) {
                    sliderEl.classList.add('d-none');
                    sliderEl.classList.remove('d-flex');
                }
                if (closeBtn)
                    closeBtn.classList.add('d-none');
            });
            modal.addEventListener('shown.bs.modal', (event) => {
                const trigger = event.relatedTarget;
                if (!trigger)
                    return;
                const index = parseInt(trigger.dataset.splideIndex || '0', 10);
                const modalElement = modal;
                const modalIdSuffix = modalElement.id.split('-').pop();
                const splideId = `#splide-gallery-modal-${modalIdSuffix}`;
                const sliderEl = document.querySelector(splideId);
                const loader = modalElement.querySelector('.loading-results');
                const closeBtn = modalElement.querySelector('.close-btn');
                if (!sliderEl)
                    return;
                initWhenReady(() => {
                    Slider.goTo(splideId, index);
                });
                sliderEl.classList.remove('d-none');
                sliderEl.classList.add('d-flex');
                if (closeBtn)
                    closeBtn.classList.remove('d-none');
                if (loader)
                    loader.classList.add('d-none');
            });
        });
    }
}
export function setOrigen(origen) {
    formState.manageState('origen', origen);
}
export function nameForm(id, name) {
    const valueFields = 8;
    let formName = `#form-blog-${id}`;
    let referrer = 'Blog';
    let origen = formState.manageState('origen').includes('Blog') ? formState.manageState('origen') : 'Blog';
    if (name === 'Feria') {
        formName = '#fairForm';
        origen = 'Feria pop up';
        referrer = 'Feria';
    }
    formState.manageState('formName', formName);
    formState.manageState('origen', origen);
    formState.manageState('anuncio', name);
    formState.manageState('referrer', referrer);
    formState.manageState('valueFields', valueFields);
}
function initAutoScroll(containerSelector, scrollSpeed = 0.4) {
    const container = document.querySelector(containerSelector);
    if (!container) {
        console.error(`No se encontró el contenedor con selector: ${containerSelector}`);
        return;
    }
    let direction = 1;
    let accumulatedScroll = 0;
    let paused = false;
    let animationId = null;
    let maxScrollLeft = 0;
    let currentScrollLeft = 0;
    const recalculateBounds = () => {
        maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
        currentScrollLeft = container.scrollLeft;
    };
    const autoScroll = () => {
        if (!paused && maxScrollLeft > 0) {
            accumulatedScroll += scrollSpeed * direction;
            if (Math.abs(accumulatedScroll) >= 1) {
                const scrollStep = Math.trunc(accumulatedScroll);
                accumulatedScroll -= scrollStep;
                currentScrollLeft += scrollStep;
                if (currentScrollLeft >= maxScrollLeft) {
                    currentScrollLeft = maxScrollLeft;
                    direction = -1;
                }
                else if (currentScrollLeft <= 0) {
                    currentScrollLeft = 0;
                    direction = 1;
                }
                container.scrollLeft = currentScrollLeft;
            }
        }
        animationId = requestAnimationFrame(autoScroll);
    };
    const pause = () => {
        paused = true;
    };
    const resume = () => {
        paused = false;
    };
    recalculateBounds();
    const resizeObserver = new ResizeObserver(() => {
        recalculateBounds();
    });
    resizeObserver.observe(container);
    container.addEventListener("mouseenter", pause);
    container.addEventListener("mouseleave", resume);
    container.addEventListener("focusin", pause);
    container.addEventListener("focusout", resume);
    container.addEventListener("scroll", () => {
        currentScrollLeft = container.scrollLeft;
    }, { passive: true });
    autoScroll();
}
const featuredZoneList = [
    { name: 'Bogotá D.C', shortName: 'bogota', id: 'bogotaFigure', zoneId: '19992', cities: '20624', department: '20612', url: '/proyectos-vivienda/bogota' },
    { name: 'Cali y Alrededores', shortName: 'cali', id: 'caliFigure', zoneId: '19993', cities: '20627', department: '20620', url: '/proyectos-vivienda?cityId=20627' },
    { name: 'Medellín y Alrededores', shortName: 'medellin', id: 'medellinFigure', zoneId: '19994', cities: '20642,20631', department: '20605', url: '/proyectos-vivienda?cityId=20642,20631' },
    { name: 'Eje Cafetero', shortName: 'eje_cafetero', id: 'ejeCafeteroFigure', zoneId: '19996', cities: '20621,29663', department: '20616', url: '/proyectos-vivienda?cityId=20621,29663' },
    { name: 'Sabana de Bogotá', shortName: 'sabana', id: 'sabanaFigure', zoneId: '30443', cities: '20626,20629,20644,20662', department: '20612', url: '/proyectos-vivienda?cityId=20626,20629,20644,20662' },
    { name: 'Barranquilla', shortName: 'barranquilla', id: 'barranquillaFigure', zoneId: '30991', cities: '20622,32239,20649', department: '20606', url: '/proyectos-vivienda?cityId=20622,32239,20649' },
    { name: 'Cartagena', shortName: 'cartagena', id: 'cartagenaFigure', zoneId: '30993', cities: '20628', department: '20607', url: '/proyectos-vivienda/cartagena' },
    { name: 'Santa Marta', shortName: 'santa_marta', id: 'santaMartaFigure', zoneId: '30995', cities: '20653', department: '20614', url: '/proyectos-vivienda/santa-marta' },
    { name: 'Bucaramanga y Alrededores', shortName: 'bucaramanga', zoneId: '34099', id: 'bucaramangaFigure', cities: '20625,20632,29437', department: '20618', url: '/proyectos-vivienda?cityId=20625,20632,29437' }
    // { name: 'Bucaramanga y Alrededores', shortName: 'bucaramanga', zoneId: '34322', id: 'bucaramangaFigure', cities: '20625,20632,29437', department: '20618', url: '/proyectos-vivienda?cityId=20625,20632,29437' }
];
async function getProjectsCounter() {
    for (const zone of featuredZoneList) {
        const apiResult = await projectsCounterAPI(zone.cities, zone.department);
        if (apiResult) {
            document.querySelector(`#${zone.id} .counter-projects`).textContent = '+' + apiResult.NumItems + ' Inmuebles';
            // document.querySelector(`#${zone.id} #${zone.id}Url`)!.setAttribute('href', zone.url);
            document.querySelector(`#${zone.id}`).setAttribute('data-cities', zone.cities);
            document.querySelector(`#${zone.id}`).setAttribute('data-zone-name', zone.name);
            document.querySelector(`#${zone.id}`).setAttribute('data-short-name', zone.shortName);
        }
    }
}
async function projectsCounterAPI(cities, department) {
    let counterResult = await fetch(`/results-api?section_type=property_type&cities=${cities}&department_list=${department}`);
    return counterResult.json();
}
const activateTabByZoneId = (zoneId) => {
    const tabTrigger = document.querySelector(`.ev-tabs-column__item[data-zone-id="${zoneId}"]`);
    if (!tabTrigger)
        return;
    if (typeof bootstrap !== 'undefined' && bootstrap.Tab) {
        new bootstrap.Tab(tabTrigger).show();
    }
    else {
        tabTrigger.click();
    }
    scrollTabIntoView(tabTrigger);
};
export const initFeaturedZones = () => {
    const featuredZones = document.querySelector('#featured-zones');
    const featuredProject = document.querySelector('#featured-project');
    if (!featuredZones || !featuredProject)
        return;
    featuredZones.addEventListener('click', (event) => {
        const target = event.target;
        const button = target.closest('button[data-zone-id]');
        if (!button)
            return;
        event.preventDefault();
        const zoneId = button.dataset.zoneId;
        if (!zoneId)
            return;
        featuredProject.classList.add('is-visible');
        activateTabByZoneId(zoneId);
        featuredZones.classList.add('d-none');
    });
};
export const assignZoneLinks = () => {
    const panes = document.querySelectorAll('.tab-pane[data-zone-id]');
    panes.forEach((pane) => {
        const currentPane = pane;
        const zoneId = currentPane.dataset.zoneId;
        const link = currentPane.querySelector('.js-zone-link');
        if (!zoneId || !link)
            return;
        const zoneData = featuredZoneList.find((zone) => zone.zoneId === zoneId);
        if (!zoneData)
            return;
        link.href = zoneData.url;
    });
};
export function openZonesMap() {
    var _a, _b;
    (_a = document.getElementById('homeMapRender')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
    (_b = document.getElementById('homeMapImg')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
}
async function loadInitialMarkers() {
    let datosMapSet;
    const datosMap = await fetch(`/results-api/map?section_type=property_type&url=/proyectos-vivienda&range=100`);
    datosMapSet = await datosMap.json();
    getCardMap(datosMapSet, true);
}
